import React, { ReactNode, useEffect, useRef } from 'react';

import { StyledInner, StyledOuter, StyledSeperator } from './grid-container.styles';

const GridContainer = ({ index, className, children, spaceBefore, noSpaceAfter, extraSpaceBefore, extraSpaceAfter, mask, relative, seperator, removeSpaceAfter, removeExtraSpaceAfter, verticalSpace }: { index: number, className?: string, children: ReactNode, noSpaceAfter?: boolean, spaceBefore?: boolean, extraSpaceBefore?: boolean, extraSpaceAfter?: boolean, relative?: boolean, mask?: boolean, seperator?: boolean, removeSpaceAfter?: boolean, removeExtraSpaceAfter?: boolean, verticalSpace?: "small" | "medium" | "large" }) => {

	const ref = useRef();

	useEffect(() => {
		const handleIntersection = (entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					console.log('Element in view:', entry.target);
					// Add custom logic for when the element is in view
				}
			});
		}

		// Create IntersectionObserver instance
		const observerOptions = {
			root: null, // relative to the viewport
			rootMargin: '0px',
			threshold: 0.1 // 10% of the element's area is visible
		};

		const observer = new IntersectionObserver(handleIntersection, observerOptions);

		if (ref.current) {
			observer.observe(ref.current)
		}

		return () => {
			if (ref.current) {
				observer.unobserve(ref.current)
			}
		}

	}, []);

	return (
		<StyledOuter ref={ref} data-scroll-index={index} className={className} $noSpaceAfter={noSpaceAfter} $spaceBefore={spaceBefore} $extraSpaceBefore={extraSpaceBefore} $extraSpaceAfter={extraSpaceAfter}>
			<StyledInner $mask={mask} $relative={relative} $removeSpaceAfter={removeSpaceAfter} $removeExtraSpaceAfter={removeExtraSpaceAfter} $verticalSpace={verticalSpace}>
				{children}
			</StyledInner>
			{seperator &&
				<StyledSeperator width="135" height="43" viewBox="0 0 135 43" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect y="0.710721" width="29.251" height="29.251" transform="matrix(0.703474 0.710721 -0.703474 0.710721 68.2129 0.205597)" stroke="#232122" />
					<rect x="97.1655" y="21.7183" width="37.8344" height="0.868729" fill="#232122" />
					<rect y="21.7183" width="37.8344" height="0.868729" fill="#232122" />
				</StyledSeperator>
			}
		</StyledOuter>
	)
}

export default GridContainer;